import React, {ReactNode} from 'react';

import styled from 'styled-components';

import {
  HIGHLIGHT_HOVERED_CLASS,
  HIGHLIGHT_TEXT_CLASS,
  TEXT_HIGHLIGHT_ANIMATION_PREFIX,
  TEXT_HIGHLIGHT_CLASS_PREFIX,
} from 'app/general/structures/UserContentContainer/utils/highlightUtils';

import {useTextHighlights} from '../TextHighlightsContextProvider';

import type {TextHighlightType} from '../types';

const DefineHighlightsDiv = styled.div<{
  highlights: Array<TextHighlightType>;
}>`
  ${({highlights}) =>
    highlights.map(
      (highlight) => `
         @keyframes ${TEXT_HIGHLIGHT_ANIMATION_PREFIX}${highlight.id} {
            from {
              background-color: ${highlight.colorLight};
            }
            to {
              background-color: ${highlight.color};
            }
          }
         
         .${TEXT_HIGHLIGHT_CLASS_PREFIX}${highlight.id} {
            &.${HIGHLIGHT_TEXT_CLASS} {
              background-color: ${highlight.colorLight};
            }
            
            &.${HIGHLIGHT_HOVERED_CLASS} {
              animation: ${TEXT_HIGHLIGHT_ANIMATION_PREFIX}${highlight.id} 1s ease;
              animation-fill-mode: forwards;
            }
         }
     `
    )}
`;

export const HighlightAnimations = ({children}: {children: ReactNode}) => {
  const {highlights} = useTextHighlights();

  return (
    <DefineHighlightsDiv
      className={'DefineHighlightsDiv'}
      highlights={Object.values(highlights)}
    >
      {children}
    </DefineHighlightsDiv>
  );
};
